import { Popover, Stack, Typography, IconButton, List, Box, ListItem, Button, Chip, useTheme } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { renderColorByString } from 'components/DataGrid/renderColorByString'

const GridFiltersPopover = ({
  open,
  anchorEl,
  closeMore,
  hiddenFilters,
  setFilterModel,
  deleteFilter,
}: {
  open: boolean
  anchorEl: HTMLElement | null
  closeMore: () => void
  hiddenFilters: { label: string; field: string; value: string | number | boolean; isExcluded?: boolean; color?: string }[]
  setFilterModel: React.Dispatch<
    React.SetStateAction<{
      items: { field: string; operator: string; value: string | number | boolean }[]
      quickFilterValues: string[]
    }>
  >
  deleteFilter: (_field: string, _value: string | number | boolean) => void
}) => {
  const theme = useTheme()

  // Guard against invalid anchorEl - don't render if anchor is not in the DOM
  if (!anchorEl || !document.body.contains(anchorEl)) {
    return null
  }

  return (
    <Popover
      open={open && Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={closeMore}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      transformOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      slotProps={{ paper: { elevation: 3, sx: { p: 1 } } }}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ px: 1, pb: 1 }}>
        <Typography variant="subtitle2">Active Filters</Typography>
        <IconButton size="small" onClick={closeMore}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </Stack>

      <Box sx={{ maxHeight: 260, overflowY: 'auto', pr: 0.5 }}>
        <List dense disablePadding>
          {hiddenFilters.map(({ label, field, value, isExcluded, color }, idx) => (
            <ListItem
              key={`${field}-${value}-hidden-${idx}`}
              disableGutters
              onClick={() => deleteFilter(field, value)}
              //   secondaryAction={
              //     <IconButton
              //       size="small"
              //       edge="end"
              //       onClick={() => deleteFilter(field, value)}
              //       aria-label={`remove ${label}`}
              //     >
              //       <CloseIcon fontSize="inherit" />
              //     </IconButton>
              //   }
              sx={{ px: 1, '&:hover': { cursor: 'pointer', opacity: 0.7 } }}
            >
              <Chip
                label={
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    {isExcluded && (
                      <Typography sx={{ fontSize: 12, fontWeight: 700, color: theme.palette.text.disabled }}>
                        🚫
                      </Typography>
                    )}
                    <Typography
                      sx={{
                        fontSize: 12,
                        fontWeight: 700,
                        opacity: isExcluded ? 0.4 : 1,
                        textDecoration: isExcluded ? 'line-through' : 'none',
                        color: color ?? renderColorByString(label),
                      }}
                    >
                      {label}
                    </Typography>
                  </Box>
                }
                size="small"
                sx={{ backgroundColor: 'background.defaultdim' }}
              />
            </ListItem>
          ))}
        </List>
      </Box>

      <Stack direction="row" justifyContent="flex-end" sx={{ pt: 1, px: 1 }}>
        <Button
          variant="text"
          size="small"
          onClick={() => {
            setFilterModel({ items: [], quickFilterValues: [] })
            closeMore()
          }}
        >
          Clear all
        </Button>
        {/* <Button variant="contained" size="small" onClick={closeMore}>
          Close
        </Button> */}
      </Stack>
    </Popover>
  )
}

export default GridFiltersPopover
